import { Typography } from '@mui/material'
import { forwardRef } from 'react'

export interface IOvFormInputReadOnly {
  label?: string
  value?: any
  children?: React.ReactNode
  boldValue?: boolean
}

const OvFormInputReadOnly = forwardRef<HTMLDivElement, IOvFormInputReadOnly>(
  ({ label, value, children, boldValue = false }, ref) => (
    <span ref={ref}>
      {label && (
        <Typography
          variant="h5"
          sx={({ palette }) => ({ color: palette.primary.main, mb: 1, fontWeight: 600 })}>
          {label}
        </Typography>
      )}
      {value && (
        <Typography
          variant="body2"
          sx={{
            whiteSpace: 'pre-line',
            ...(boldValue && { fontWeight: 600 })
          }}>
          {value}
        </Typography>
      )}
      {children}
    </span>
  )
)

OvFormInputReadOnly.displayName = 'OvFormInput'

export { OvFormInputReadOnly }
